module.exports = __webpack_public_path__ + "assets/099bf1e0a631cd3bbb02ae7a7d0f18b8.jpg";